// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ar_card {
  margin-bottom: 5px;
}

.lessions-data-ore {
  float: left;
  margin-left: 50%;
  font-size: 1rem;
  margin-top: 0.2rem;
}

.lessions-tot-presenze {
  float: right;
  margin-left: 4px;
}

.lessions-data-n-studenti {
  float: right;
  margin-left: 4px;
}

.empty-div-fr {
  float: right;
}

.empty-div-fl {
  float: right;
}

.lessions-data-ore-out {
  float: right;
  margin-top: 0.6rem;
}

.lessions-data-n-studenti-out {
  float: left;
  margin-left: 4px;
  margin-top: 0.5rem;
}

.lessions-tot-presenze-out {
  float: left;
  margin-left: 4px;
  margin-top: 0.5rem;
}

.historyicon {
  margin-left: 2px;
  margin-top: 0.2rem;
  float: left;
  font-size: 1rem;
}

.icon-warning {
  margin-bottom: -2px;
}

.progress-ar {
  margin-bottom: 5px;
}

.flex {
  display: flex;
  align-items: center;
  color: #4D4D4D;
}
.flex ms3-icon {
  font-size: 30px;
  margin-right: 1rem;
  color: #4D4D4D;
}
.flex .no-margin {
  font-size: 18px;
  margin-right: 0;
  color: var(--ion-color-primary);
}

.grid {
  margin: 1rem 0 1rem 0;
  display: grid;
  grid-gap: 1rem 2rem;
  grid-template-columns: auto auto;
}

.box-btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-btns .btns {
  margin: 0 0.5rem;
  width: unset;
}
.box-btns .big-icon {
  font-size: 30px;
}

.info-popover {
  width: 80%;
}

.radio-group-inline-wrapper {
  --padding-start: 0;
  --inner-padding-end: 0;
  align-items: flex-start;
}
.radio-group-inline-wrapper ion-label.label-header {
  margin-right: 6px;
  white-space: nowrap;
  overflow: visible;
}
.radio-group-inline-wrapper .radio-inline {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
}
.radio-group-inline-wrapper .radio-option {
  display: flex;
  align-items: center;
  gap: 6px;
}
.radio-group-inline-wrapper .radio-option ion-radio {
  --color: var(--ion-color-primary);
  transform: scale(0.9);
}
.radio-group-inline-wrapper .radio-option .radio-label {
  font-size: 14px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ar-viewer/ar-viewer.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AACA;EACE,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,YAAA;EACA,kBAAA;AAGF;;AAAA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAGF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAGF;AAFE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAIJ;AAFE;EACE,eAAA;EACA,eAAA;EACA,+BAAA;AAIJ;;AADA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AAIF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAKF;AAJE;EACE,gBAAA;EACA,YAAA;AAMJ;AAJE;EACE,eAAA;AAMJ;;AAFA;EACE,UAAA;AAKF;;AAFA;EACE,kBAAA;EACA,sBAAA;EACA,uBAAA;AAKF;AAHE;EAEE,iBAAA;EACA,mBAAA;EACA,iBAAA;AAIJ;AADE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AAGJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAEJ;AAAI;EACE,iCAAA;EACA,qBAAA;AAEN;AACI;EACE,eAAA;EACA,mBAAA;AACN","sourcesContent":[".ar_card {\n  margin-bottom: 5px;\n}\n\n.lessions-data-ore {\n  float: left;\n  margin-left: 50%;\n  font-size: 1rem;\n  margin-top: 0.2rem;\n}\n.lessions-tot-presenze {\n  float: right;\n  margin-left: 4px;\n}\n\n.lessions-data-n-studenti {\n  float: right;\n  margin-left: 4px;\n}\n\n.empty-div-fr {\n  float: right;\n}\n.empty-div-fl {\n  float: right;\n}\n\n.lessions-data-ore-out {\n  float: right;\n  margin-top: 0.6rem;\n}\n\n.lessions-data-n-studenti-out {\n  float: left;\n  margin-left: 4px;\n  margin-top: 0.5rem;\n}\n\n.lessions-tot-presenze-out {\n  float: left;\n  margin-left: 4px;\n  margin-top: 0.5rem;\n}\n\n.historyicon {\n  margin-left: 2px;\n  margin-top: 0.2rem;\n  float: left;\n  font-size: 1rem;\n}\n\n.icon-warning {\n  margin-bottom: -2px;\n}\n\n.progress-ar {\n  margin-bottom: 5px;\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n  color: #4D4D4D;\n  ms3-icon {\n    font-size: 30px;\n    margin-right: 1rem;\n    color: #4D4D4D;\n  }\n  .no-margin {\n    font-size: 18px;\n    margin-right: 0;\n    color: var(--ion-color-primary);\n  }\n}\n.grid {\n  margin: 1rem 0 1rem 0;\n  display: grid;\n  grid-gap: 1rem 2rem;\n  grid-template-columns: auto auto;\n}\n.box-btns {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .btns {\n    margin: 0 0.5rem;\n    width: unset;\n  }\n  .big-icon {\n    font-size: 30px;\n  }\n}\n\n.info-popover {\n  width: 80%; \n}\n\n.radio-group-inline-wrapper {\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  align-items: flex-start;\n\n  ion-label.label-header {\n    // font-weight: bold;\n    margin-right: 6px;\n    white-space: nowrap;\n    overflow: visible;\n  }\n\n  .radio-inline {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .radio-option {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    ion-radio {\n      --color: var(--ion-color-primary);\n      transform: scale(0.9);\n    }\n\n    .radio-label {\n      font-size: 14px;\n      white-space: nowrap;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
